export const ORDER_SERVICE_MAPPABLE_FIELDS = [
  {
    path: "status",
    label: "Order Status",
    group: "Order",
    compatibleFieldTypes: ["SELECT", "SELECT_ORDER_STATUS"],
    valueInput: "orderStatus",
  },
  {
    path: "provider",
    label: "Provider / Insurer",
    group: "Order",
    compatibleFieldTypes: ["REF_PROVIDER"],
  },
  {
    path: "address",
    label: "Address",
    group: "Address",
    compatibleFieldTypes: ["TEXT", "TEXTAREA"],
  },
  {
    path: "payment.premium",
    label: "Premium",
    group: "Payment",
    compatibleFieldTypes: ["INTEGER", "DECIMAL_2", "DECIMAL_4"],
  },
  {
    path: "payment.currency",
    label: "Currency",
    group: "Payment",
    compatibleFieldTypes: ["TEXT", "SELECT"],
  },
  {
    path: "payment.paymentTerm",
    label: "Payment Term (Years)",
    group: "Payment",
    compatibleFieldTypes: ["INTEGER"],
  },
  {
    path: "payment.paymentTermUntilAge",
    label: "Payment Term Until Age",
    group: "Payment",
    compatibleFieldTypes: ["INTEGER"],
  },
  {
    path: "payment.policyTerm",
    label: "Policy Term",
    group: "Payment",
    compatibleFieldTypes: ["INTEGER"],
  },
  {
    path: "payment.payMode",
    label: "Pay Mode",
    group: "Payment",
    compatibleFieldTypes: ["TEXT", "SELECT"],
  },
  {
    path: "payment.payStatus",
    label: "Pay Status",
    group: "Payment",
    compatibleFieldTypes: ["TEXT", "SELECT"],
  },
  {
    path: "payment.payCount",
    label: "Payment Count",
    group: "Payment",
    compatibleFieldTypes: ["INTEGER"],
  },
  {
    path: "payment.payBy",
    label: "Pay By",
    group: "Payment",
    compatibleFieldTypes: ["TEXT", "SELECT"],
  },
  {
    path: "payment.sumInsured",
    label: "Sum Insured",
    group: "Payment",
    compatibleFieldTypes: ["INTEGER", "DECIMAL_2", "DECIMAL_4"],
  },
  {
    path: "payment.initialPayment",
    label: "Initial Payment",
    group: "Payment",
    compatibleFieldTypes: ["INTEGER", "DECIMAL_2", "DECIMAL_4"],
  },
  {
    path: "payment.levy",
    label: "Levy",
    group: "Payment",
    compatibleFieldTypes: ["INTEGER", "DECIMAL_2", "DECIMAL_4"],
  },
  {
    path: "payment.maturityDate",
    label: "Maturity Date",
    group: "Payment",
    compatibleFieldTypes: ["DATE"],
  },
  {
    path: "payment.payUpDate",
    label: "Paid Up Date",
    group: "Payment",
    compatibleFieldTypes: ["DATE"],
  },
  {
    path: "payment.preliminaryDate",
    label: "Preliminary Date",
    group: "Payment",
    compatibleFieldTypes: ["DATE"],
  },
  {
    path: "remark",
    label: "Remarks",
    group: "Order",
    compatibleFieldTypes: ["TEXT", "TEXTAREA"],
  },
  {
    path: "totalWithdrawalAmount",
    label: "Total Withdrawal Amount",
    group: "Payment",
    compatibleFieldTypes: ["INTEGER", "DECIMAL_2", "DECIMAL_4"],
  },
  {
    path: "fnaSignDate",
    label: "FNA Sign Date",
    group: "Policy",
    compatibleFieldTypes: ["DATE"],
  },
  {
    path: "policyAckSignDate",
    label: "Policy Acknowledge Date",
    group: "Policy",
    compatibleFieldTypes: ["DATE"],
  },
  {
    path: "transferInEffectiveDate",
    label: "Transfer In Effective Date",
    group: "Policy",
    compatibleFieldTypes: ["DATE"],
  },
  {
    path: "lapsedSurrenderDate",
    label: "Lapsed/Surrender Date",
    group: "Policy",
    compatibleFieldTypes: ["DATE"],
  },
  {
    path: "transferOutDate",
    label: "Transfer Out Date",
    group: "Policy",
    compatibleFieldTypes: ["DATE"],
  },
  {
    path: "reinstateDate",
    label: "Reinstate Date",
    group: "Policy",
    compatibleFieldTypes: ["DATE"],
  },
  {
    path: "signedDate",
    label: "Signed Date",
    group: "Policy",
    compatibleFieldTypes: ["DATE"],
  },
  {
    path: "signedPlace",
    label: "Signed Place",
    group: "Policy",
    compatibleFieldTypes: ["TEXT", "SELECT"],
  },
  {
    path: "policyCommenceDate",
    label: "Policy Commence Date",
    group: "Policy",
    compatibleFieldTypes: ["DATE"],
  },
  {
    path: "policyIssueDate",
    label: "Policy Issue Date",
    group: "Policy",
    compatibleFieldTypes: ["DATE"],
  },
  {
    path: "policyCoolingOffDate",
    label: "Policy Cooling Off Date",
    group: "Policy",
    compatibleFieldTypes: ["DATE"],
  },
  {
    path: "policyRemark",
    label: "Policy Remark",
    group: "Policy",
    compatibleFieldTypes: ["TEXT", "TEXTAREA"],
  },
  {
    path: "policyDeliverMethod",
    label: "Policy Deliver Method",
    group: "Policy",
    compatibleFieldTypes: ["TEXT", "SELECT"],
  },
  {
    path: "policyDeliverDate",
    label: "Policy Deliver Date",
    group: "Policy",
    compatibleFieldTypes: ["DATE"],
  },
];

export const getMappableFieldByPath = (path) =>
  ORDER_SERVICE_MAPPABLE_FIELDS.find((field) => field.path === path);

export const getMappableFieldsForFieldType = (fieldType) =>
  ORDER_SERVICE_MAPPABLE_FIELDS.filter((field) =>
    field.compatibleFieldTypes.includes(fieldType)
  );

export const getMappableFieldOptions = (fieldType) =>
  getMappableFieldsForFieldType(fieldType).map((field) => ({
    value: field.path,
    label: `${field.group} — ${field.label}`,
  }));
